import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=09b4a5e6&scoped=true&"
import script from "./layout.vue?vue&type=script&lang=ts&"
export * from "./layout.vue?vue&type=script&lang=ts&"
import style0 from "./layout.vue?vue&type=style&index=0&id=09b4a5e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b4a5e6",
  null
  
)

export default component.exports